/**
 * Shared drag-and-drop type constants and item interfaces
 * for react-dnd across Views 1 and 2.
 */

export const ItemTypes = {
  CARD: 'CARD',
  COLUMN: 'COLUMN',
} as const;

/** Drag item shape for cards */
export interface CardDragItem {
  type: typeof ItemTypes.CARD;
  id: number; // ConversationId
  columnId: number; // DashboardGroupId of origin
  dashboardId?: number; // DashboardId of origin
  parentId?: number; // ParentConversationId (if nested child)
}

/** Drag item shape for columns */
export interface ColumnDragItem {
  type: typeof ItemTypes.COLUMN;
  id: number; // DashboardGroupId
  index: number; // position in column order
}
